module.exports = __webpack_public_path__ + "img/avatar7.ee20f2e5.png";